"use client";

interface FilterOptionProps {
  value: string;
  label: string;
  suffix?: string;
  isSelected: boolean;
  categoryKey: string;
  onChange: (category: string, value: string) => void;
}

export function FilterOption({ 
  value, 
  label, 
  suffix, 
  isSelected, 
  categoryKey, 
  onChange 
}: FilterOptionProps) {
  return (
    <div className="flex items-center">
      <label className="flex items-center cursor-pointer text-[12px] font-mono text-zinc-700 hover:text-black">
        <input
          type="checkbox"
          className="sr-only"
          checked={isSelected}
          onChange={() => onChange(categoryKey, value)}
        />
        <span 
          className={`inline-block w-3 h-3 mr-2 border border-zinc-400 rounded-full ${
            isSelected ? 'bg-zinc-500' : 'bg-transparent'
          } transition-colors duration-200 ease-in-out`}
        ></span>
        <span className="transition-colors duration-200 ease-in-out">{label}</span>
        {suffix && <span className="ml-1 text-zinc-400 text-[10px] transition-colors duration-200 ease-in-out">{suffix}</span>}
      </label>
    </div>
  );
}
